import p from 'package.json'

export const newrelicIdentifier = ({
  ocaId,
  email,
  phone,
}: {
  ocaId: string
  email: string
  phone: string
}): void => {
  try {
    if (!window?.NREUM || !!ocaId) return

    window.NREUM.setUserId(ocaId)
    window.NREUM.setCustomAttribute('email', email)
    window.NREUM.setCustomAttribute('phone', phone)
  } catch (e) {
    console.error(e)
  }
}

export const newrelicTrackWebVersion = (): void => {
  try {
    if (!window?.NREUM) return
    const version = p.version
    window.NREUM.setCustomAttribute('shop-version', version)
  } catch (e) {
    console.error(e)
  }
}

export const newrelicTrackOrderStoreId = (storeOrderId?: string): void => {
  try {
    if (!window?.NREUM || !storeOrderId) return
    window.NREUM.setCustomAttribute('storeOrderId', storeOrderId)
  } catch (e) {
    console.error(e)
  }
}

export const newrelicTrackUserAction = (actionName: string, attributes?: Record<string, unknown>): void => {
  try {
    if (!window?.NREUM || !actionName) return
    window.NREUM.addPageAction(actionName, attributes)
  } catch (e) {
    console.error(e)
  }
}
